import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import Contribuer from "@/pages/Contribuer";
import Marque from "@/pages/Marque";
import Merci from "@/pages/Merci";
import NotFound from "@/pages/NotFound";

// Version de lancement : seules les pages publiques sont routées.
// Les composants éditoriaux (articles, dossiers, auteur) restent dans le code
// pour une réutilisation ultérieure, mais ne sont pas accessibles publiquement.
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/contribuer" element={<Contribuer />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/marque" element={<Marque />} />
            {/* Anciennes routes : redirections vers les pages de lancement */}
            <Route path="/articles" element={<Navigate to="/" replace />} />
            <Route path="/dossiers" element={<Navigate to="/" replace />} />
            <Route path="/methode" element={<Navigate to="/a-propos" replace />} />
            <Route path="/corrections" element={<Navigate to="/a-propos" replace />} />
            <Route path="/droit-de-reponse" element={<Navigate to="/contact" replace />} />
            <Route
              path="/merci-contact"
              element={
                <Merci
                  kicker="Message transmis"
                  title="Votre message a bien été envoyé"
                  message="Merci d'avoir écrit à Contre-épreuve."
                  steps={[
                    "Votre message est lu par la rédaction.",
                    "Une réponse est apportée lorsque la demande le nécessite. Toutes les demandes ne donnent pas nécessairement lieu à une réponse individuelle.",
                  ]}
                  note="Délai de réponse indicatif : quelques jours ouvrés. Les demandes de rectification sont traitées en priorité."
                  testid="merci-contact"
                />
              }
            />
            <Route
              path="/merci-contribution"
              element={
                <Merci
                  kicker="Proposition transmise"
                  title="Votre proposition a bien été envoyée"
                  message="Merci pour votre proposition."
                  steps={[
                    "Chaque proposition est examinée avant toute décision de publication.",
                    "Si le sujet est retenu, la rédaction revient vers vous pour préciser l'angle et les sources.",
                    "Aucun texte n'est publié sous le nom d'un contributeur sans son accord.",
                  ]}
                  note="Délai indicatif d'examen : jusqu'à deux semaines. L'envoi d'une proposition ne garantit ni son utilisation ni sa publication."
                  testid="merci-contribution"
                />
              }
            />
            <Route
              path="/merci-newsletter"
              element={
                <Merci
                  kicker="Inscription enregistrée"
                  title="Vous serez prévenu au lancement"
                  message="Merci. Votre adresse a bien été enregistrée."
                  steps={[
                    "Vous recevrez un seul message, le jour de la première publication de Contre-épreuve.",
                    "Aucune lettre d'information régulière, aucune donnée transmise à des tiers.",
                  ]}
                  note="Vous pouvez demander le retrait de votre adresse à tout moment depuis la page Contact."
                  testid="merci-newsletter"
                />
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
